/**
 * Custom JS
 */

function initLoadMore() {
  var btn = document.querySelector('.load-more-btn');
  if (!btn) return;

  var perPage = parseInt(btn.getAttribute('data-per-page')) || 12;
  var list = document.querySelector('.collection__main product-list');
  if (!list) return;

  var cards = Array.from(list.querySelectorAll('product-card'));

  // Hide all beyond first page
  cards.forEach(function(card, i) {
    if (i >= perPage) card.style.display = 'none';
  });

  var wrap = btn.closest('.load-more-wrap');

  // Hide button if all fit
  if (cards.length <= perPage) {
    wrap.style.display = 'none';
    return;
  }

  btn.addEventListener('click', function() {
    var hidden = cards.filter(function(c) { return c.style.display === 'none'; });
    hidden.slice(0, perPage).forEach(function(card) {
      card.style.display = '';
    });
    if (hidden.length <= perPage) {
      wrap.style.display = 'none';
    }
  });
}

// If whats-new already ran and set the flag, init immediately
// Otherwise wait for the flag event
if (window.__collectionFiltered) {
  initLoadMore();
} else {
  document.addEventListener('collection:filtered', initLoadMore);
}